export class EscritoFilter {
  descripcion!: string | null;  // Descripción del escrito (nullable)
  titulo!: string | null;  // Título del escrito (nullable)
  cuerpoHTML!: string | null;  // Cuerpo en HTML del escrito (nullable)
  fechaCreacionDesde!: string;  // Fecha de creación en formato date-time
  fechaCreacionHasta!: string;  // Fecha de creación en formato date-time
  idsEstadoEscrito!: number[] | null;  // ID del estado del escrito (nullable)
  idsExpediente!: number[] | null;  // ID del expediente (nullable)
  idsTipoEscrito!: number[] | null;  // ID del tipo de escrito (nullable)


}
